import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/site";

export default function IntroSection() {
  return (
    <section className="w-full bg-primary-500">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-16 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
            <i className="ri-quill-pen-line" />
            关于国产自拍
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            专注国产原创影视的内容平台
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
            国产自拍致力于发现与推广国产自制影视作品，覆盖电影、电视剧与综艺三大内容板块。
            我们每周整理最新上线的国产原创内容，从题材、导演到演员阵容，帮助影迷更快找到想看的作品，
            也让更多优秀的中文原创影视被看见。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-compass-3-line text-lg" />
              开始浏览
            </Link>
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-100 transition-colors hover:bg-primary-600"
            >
              <i className="ri-information-line text-lg" />
              了解我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-primary-400 bg-primary-600 p-5"
            >
              <p className="font-heading text-2xl font-black text-secondary-400 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1.5 text-xs text-primary-100 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}